import * as React from "react";
import {useEffect, useState} from "react";
import {useAPI} from "../../api/API";

const M2MSelect = (props) => {
    /**
     * Компонент для работы с m2m полями.
     * Props:
     *  - availableItems - Структура для отображения возможных для выбора элементов
     *      id: string | number - Значение опции
     *      name: string - Наименование опции
     *  - apiMethodName - метод, который должен находиться в объекте useAPI,
     *  структура должна быть аналогична availableItems TODO переделать на передачу метода
     *  - values - Список выбранных пользователем Id из структуры
     */
    const MAX_SELECT_ITEMS = 4

    const [availableItems, setAvailableItems] = useState(props.avaliableItems ?? []);

    const api = useAPI();

    useEffect(() => {
        if (props.apiMethodName) {
            api[props.apiMethodName]()
                .then((data) => setAvailableItems(data))
                .catch((error) => console.log(error));
        }
    }, [api, props.apiMethodName]);

    const onChangeSelect = (e) => {
       const selectedItem = Array(...e.target)
           .filter((i) => i.selected)
           .map((i) => i.value);
       props.onChange(selectedItem);
    };

    return (
        <div className="select is-multiple">
            <select
                multiple
                size={availableItems.length <= MAX_SELECT_ITEMS ? availableItems.length : MAX_SELECT_ITEMS}
                onChange={onChangeSelect}
                style={{height: '40px'}}
            >
                {availableItems.map((item) => (
                    <option
                        key={item.id}
                        value={item.id}
                        selected={props.values.includes(item.id)}
                    >
                        {item.name}
                    </option>
                ))}
            </select>
        </div>
    );
};

export default M2MSelect;
